import { render, staticRenderFns } from "./HistoricoRotasOtimizadasPainel.vue?vue&type=template&id=e15b1f92&scoped=true&"
import script from "./HistoricoRotasOtimizadasPainel.vue?vue&type=script&lang=js&"
export * from "./HistoricoRotasOtimizadasPainel.vue?vue&type=script&lang=js&"
import style0 from "./HistoricoRotasOtimizadasPainel.vue?vue&type=style&index=0&id=e15b1f92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15b1f92",
  null
  
)

export default component.exports